import { Directive, AfterViewInit, Optional, Input } from '@angular/core';
import {_MatAutocompleteBase} from '@angular/material/autocomplete';
import { MatLegacyAutocompleteTrigger as MatAutocompleteTrigger } from '@angular/material/legacy-autocomplete';
import { UP_ARROW, DOWN_ARROW, TAB, ENTER } from '@angular/cdk/keycodes';

import {
  _countGroupLabelsBeforeLegacyOption as _countGroupLabelsBeforeOption,
  _getLegacyOptionScrollPosition as _getOptionScrollPosition,
} from '@angular/material/legacy-core';

const AUTOCOMPLETE_OPTION_HEIGHT=48;
const AUTOCOMPLETE_PANEL_HEIGHT=256;
@Directive({ selector: '[tab-selected]' })
export class AutoCompletTabSelected implements AfterViewInit {
  @Input() paramName: string;
  observable: any;
  auto: _MatAutocompleteBase = null;

  constructor(@Optional() private autoTrigger: MatAutocompleteTrigger) {  }

 private _scrollToOption(): void {
    const index = this.autoTrigger.autocomplete._keyManager.activeItemIndex || 0;
    const labelCount = _countGroupLabelsBeforeOption(index,
        this.autoTrigger.autocomplete.options, this.autoTrigger.autocomplete.optionGroups);

    if (index === 0 && labelCount === 1) {
      // If we've got one group label before the option and we're at the top option,
      // scroll the list to the top. This is better UX than scrolling the list to the
      // top of the option, because it allows the user to read the top group's label.
      this.autoTrigger.autocomplete._setScrollTop(0);
    } else {
      const newScrollPosition = _getOptionScrollPosition(
        index,
        AUTOCOMPLETE_OPTION_HEIGHT,
        this.autoTrigger.autocomplete._getScrollTop(),
        AUTOCOMPLETE_PANEL_HEIGHT
      );

      this.autoTrigger.autocomplete._setScrollTop(newScrollPosition);
    }
  }
              
  ngAfterViewInit() {
    this.auto = this.autoTrigger.autocomplete;
    this.autoTrigger._handleKeydown = (event: KeyboardEvent) => {
      switch (event.keyCode) {
        case UP_ARROW:
          this.autoTrigger.autocomplete._keyManager.setPreviousItemActive();
          this.autoTrigger.writeValue(this.autoTrigger.activeOption.value[this.paramName]);
          this._scrollToOption();
          break;
        case DOWN_ARROW:
          this.autoTrigger.autocomplete._keyManager.setNextItemActive();
          this.autoTrigger.writeValue(this.autoTrigger.activeOption.value[this.paramName]);
          this._scrollToOption();
          break;
        case TAB:
          this.autoTrigger.autocomplete._keyManager.setNextItemActive();
          this.autoTrigger.writeValue(this.autoTrigger.activeOption.value[this.paramName]);
          this._scrollToOption();
          event.preventDefault();
          break;
        case ENTER:
          if (this.auto.isOpen) {
            if (this.autoTrigger.activeOption) {
              this.autoTrigger.writeValue(this.autoTrigger.activeOption.value[this.paramName]);
            }
            const option = this.auto.options.find((x) => x.active);
            if (option) {
              option.select();
              event.preventDefault();
              return;
            }
          }
        default:
          return;
      }
    };

    this.observable = this.autoTrigger.panelClosingActions.subscribe(x => {
      if (!x) {
        this.autoTrigger.writeValue('');
      }
    })
    
  }
}
